import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { loadRuntimeConfig } from './app/core/config/runtime-config';
import { initI18n } from './app/core/i18n/i18n-store';

// As duas dependências de rede do boot saem juntas, não em série:
//   - /assets/config.json, para o mesmo bundle servir qualquer ambiente;
//   - /i18n/<locale>/core.json, o núcleo das traduções.
// O i18n antes era um XHR *síncrono* do idioma inteiro dentro do construtor do
// I18nService, ou seja, um segundo round-trip depois da config e com a main thread
// travada. O bundle da página vem em paralelo com o chunk dela (ver core/i18n/lazy-page).
//
// O Amplify saiu daqui: agora é configurado sob demanda pelos guards, que também são
// lazy (ver core/auth/amplify-setup.ts). Qualquer falha da config cai no fallback
// compilado, e o initI18n já trata a própria falha.
Promise.all([loadRuntimeConfig(), initI18n()])
  .then(() => bootstrapApplication(App, appConfig))
  .catch((err) => console.error(err));
